export const fonts = {
  main: `"NSG-medium", sans-serif`,
  heading: `"NSG-semi-bold", sans-serif`,
}
